import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
        <div className="text-sm text-[var(--text-secondary)] font-medium">Loading…</div>
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  if (roles && !roles.includes(user.role)) {
    return (
      <div className="min-h-screen flex items-center justify-center px-6" data-testid="auth-forbidden">
        <div className="max-w-md text-center">
          <div className="label-eyebrow mb-3">403 — Forbidden</div>
          <h2 className="text-2xl font-display font-bold">You don&apos;t have access to this view.</h2>
          <p className="text-sm text-[var(--text-secondary)] mt-2">
            Your role is <span className="font-semibold">{user.role}</span>. Switch accounts to continue.
          </p>
        </div>
      </div>
    );
  }
  return children;
}
